import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { FormattedNumber } from 'react-intl'
import classNames from 'classnames'

import { CLAN_MANAGEMENT } from 'urls'

import {
    Tooltip,
    ButtonSmall,
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap'

import {
    permissions,
    hasPermission,
} from 'utils/clan_management/roles'
import { openClanCard } from 'helpers/web_to_client'
import { treasuryPropTypes } from 'propTypes'

import { openClanSearch } from 'state/actions/app'
import requestMembersStatus from 'state/actions/clan_members_online'
import { requestClanExtendedInfo, openInvitesApplicationsWindow } from 'state/actions/CMT/ClanManagement'
import { sendEnterMainCardSoundState, playEnterMainCardSound } from 'state/actions/sounds'

import {
    CLAN_MANAGEMENT_TITLE,
    CLAN_MANAGEMENT_TOOLTIP_FOOTER,
    MEMBERS_ONLINE_TOOLTIP,
} from 'containers/ClanPanel/constants'

import {
    CLAN_TREASURY,
    ENTRYPOINT_CLAN,
    ENTRYPOINT_SEARCH,
} from '../translations'

import CurrencyTooltip from 'containers/ClanPanel/components/CurrencyTooltip/CurrencyTooltip'

import ButtonInbox from 'components/ButtonInbox/ButtonInbox'

import styles from './cards.scss'

const CLAN_MANAGEMENT_TOOLTIP_ID = 'clan_panel_management_tooltip'

export class MainCard extends React.Component {
    static propTypes = {
        clan: PropTypes.object.isRequired,
        membersOnline: PropTypes.number,
        membersTotal: PropTypes.number,
        canSeeTreasury: PropTypes.bool,
        canHandleInvites: PropTypes.bool,
        treasury: treasuryPropTypes,
        withQuests: PropTypes.bool,
        isCNRealm: PropTypes.bool,

        openInvites: PropTypes.func.isRequired,
        openClanManagement: PropTypes.func.isRequired,
        openClanSearch: PropTypes.func.isRequired,
        requestMembersStatus: PropTypes.func.isRequired,
        requestClanExtendedInfo: PropTypes.func.isRequired,
        sendEnterMainCardSoundState: PropTypes.func.isRequired,
        playEnterMainCardSound: PropTypes.func.isRequired,
    }

    componentDidMount() {
        this.props.requestMembersStatus()
        this.requestMembersTimeout = setInterval(this.props.requestMembersStatus, 3000)

        if (this.props.canHandleInvites) {
            this.props.requestClanExtendedInfo()
        }
    }

    componentWillUnmount() {
        clearInterval(this.requestMembersTimeout)
    }

    openInvites = event => {
        event.preventDefault()
        event.stopPropagation()

        this.props.openInvites()
    }

    openClanSearch = event => {
        event.preventDefault()
        event.stopPropagation()

        this.props.openClanSearch()
    }

    openClanCard = event => {
        event.preventDefault()
        event.stopPropagation()

        openClanCard({
            id: this.props.clan.id,
            tag: this.props.clan.tag,
        })
    }
    handleOpenClanManagement = () => {
        this.props.openClanManagement()
        this.props.sendEnterMainCardSoundState()
        this.props.playEnterMainCardSound()
    }
    renderTreasury = () => {
        if (!this.props.canSeeTreasury) return null

        const { crystal, gold } = this.props.treasury

        return (
            <div className={styles.treasury}>
                <h2>{CLAN_TREASURY}</h2>
                <div className={styles.currency}>
                    {crystal !== undefined && (
                        <span
                            className={classNames(styles.crystal, crystal === 0 && styles.crystal__empty)}
                            data-tip data-for='clan_panel_currency_tooltip_crystal'
                        >
                            <FormattedNumber value={crystal} />
                            <CurrencyTooltip amount={crystal} type='crystal' />
                        </span>
                    )}
                    {gold !== undefined && (
                        <span
                            className={classNames(styles.gold, gold === 0 && styles.gold__empty)}
                            data-tip data-for='clan_panel_currency_tooltip_gold'
                        >
                            <FormattedNumber value={gold} />
                            <CurrencyTooltip amount={gold} type='gold' />
                        </span>
                    )}
                </div>
            </div>
        )
    }

    renderEntryPoints = () => {
        let inbox
        if (this.props.canHandleInvites) {
            const messages = this.props.clan.applications_count > 99 ?
                '99+' :
                this.props.clan.applications_count

            inbox = (
                <ButtonInbox
                    type='miniSecondary'
                    messages={messages}
                    onClick={this.openInvites}
                    muteClick
                />
            )
        }

        return (
            <div className={styles.buttons_wrapper}>
                <ButtonSmall
                    type='miniSecondary'
                    tooltipId='entrypoint_tooltip_search'
                    onClick={this.openClanCard}
                    muteClick
                >
                    <div className={styles.icon_clan} />
                    <Tooltip id='entrypoint_tooltip_search'>
                        {ENTRYPOINT_CLAN}
                    </Tooltip>
                </ButtonSmall>
                {inbox}
                <ButtonSmall
                    type='miniSecondary'
                    tooltipId='entrypoint_tooltip_clan'
                    onClick={this.openClanSearch}
                    muteClick
                >
                    <div className={styles.icon_search} />
                    <Tooltip id='entrypoint_tooltip_clan'>
                        {ENTRYPOINT_SEARCH}
                    </Tooltip>
                </ButtonSmall>
            </div>
        )
    }

    render() {
        const mainCardClassNames = classNames(styles.main, styles.card, {
            [styles.main__cn]: !this.props.withQuests && this.props.isCNRealm,
            [styles.main__with_quests]: this.props.withQuests,
            [styles.main__with_quests_cn]: this.props.withQuests && this.props.isCNRealm,
        })

        return (
            <div
                className={mainCardClassNames}
                onClick={this.handleOpenClanManagement}
                onMouseDown={sendClickSoundCommand}
                onMouseEnter={sendHoverSoundCommand}
            >
                <h2>{CLAN_MANAGEMENT_TITLE}</h2>
                <span
                    className={styles.members_online}
                    data-tip
                    data-for={CLAN_MANAGEMENT_TOOLTIP_ID}
                >
                    <span className={styles.count_online}>
                        {this.props.membersOnline}
                    </span>
                    &nbsp;
                    <span className={styles.count_delimiter}>
                        {'/'}
                    </span>
                    &nbsp;
                    {this.props.membersTotal}
                </span>

                {this.renderTreasury()}
                {this.renderEntryPoints()}
                <Tooltip id={CLAN_MANAGEMENT_TOOLTIP_ID}>
                    <div className={styles.tooltipContent}>
                        <p className={styles.tooltipSubtitle}>
                            {CLAN_MANAGEMENT_TITLE}
                        </p>
                        <p className={styles.tooltipMessage}>
                            {MEMBERS_ONLINE_TOOLTIP(this.props.membersOnline, this.props.membersTotal)}
                        </p>
                        <p className={styles.tooltipMessage}>
                            {CLAN_MANAGEMENT_TOOLTIP_FOOTER}
                        </p>
                    </div>
                </Tooltip>
            </div>
        )
    }
}

const stateToProps = state => {
    const { membersOnline, membersTotal } = state.clanMembersOnline
    return {
        clan: state.clan,
        membersOnline,
        membersTotal,
        canSeeTreasury: state.account.permissions.see_treasury,
        canHandleInvites: hasPermission(state.account.role, permissions.HANDLE_INVITES),
        treasury: state.clan.treasury,
        isCNRealm: state.settings.isCNRealm,
    }
}

const dispatchToProps = {
    openInvites: openInvitesApplicationsWindow,
    openClanSearch,
    openClanManagement: () => push(CLAN_MANAGEMENT),
    requestMembersStatus,
    requestClanExtendedInfo,
    sendEnterMainCardSoundState,
    playEnterMainCardSound,
}

export default connect(stateToProps, dispatchToProps)(MainCard)



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/MainCard.jsx